// As we need these in multiple places we define them here and then import them as required

export const organizationFollowOptions: [string, boolean][] = [
    // ['Parents', true],
    // ['Subsidiaries', true],
    ['Investor Relations', true],
    ['Company Officers', true],
    ['Auditors', true],
    ['People', true],
    ['Involvements', true],
    ['Situations', true],
    ['Capital Structures', true],
    ['Holdings', true],
    ['Parents/Affiliates', true],
    ['Trade Exposure', true],
    ['Plans', true],
    ['Retentions', true],
    ['News Articles', true],
    ['SEC Documents', true],
]

export const peopleFollowOptions: [string, boolean][] = [
    ['Involvements', true],
    ['Capital Structures', true],
    ['Holdings', true],
    ['Retentions', true],
    ['News Articles', true],
]

export const situationFollowOptions: [string, boolean, string?][] = [
    ['Asset Sales', true],
    ['Capital Structure', true],
    ['Creditors', true],
    ['Dates', true],
    ['Documents', true, 'Docket'],
    ['Holdings', true],
    ['News', true],
    ['Plans', true],
    ['Retentions', true],
    ['KEIP/KERP', true],
    ['Roster', true],
    ['New Situation (Bankruptcy/Distress)', true],
]

export const followOptionsByArea = {
    organizations: organizationFollowOptions,
    people: peopleFollowOptions,
    situations: situationFollowOptions
}